"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monthOptions = exports.yearOptions = exports.getDayOptions = void 0;

var memoize_one_1 = __importDefault(require("@stoplight/memoize-one"));

var i18n_1 = require("./i18n");

var upperCaseFirst_1 = __importDefault(require("./upperCaseFirst"));

var getDaysInMonth = function getDaysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

var getMonthMaxDay = memoize_one_1.default(function (month, year) {
  if (!month) {
    return 31;
  }

  if (!year) {
    return getDaysInMonth(new Date(2016, month - 1, 1));
  }

  return getDaysInMonth(new Date(year, month - 1, 1));
});
exports.default = getMonthMaxDay;
exports.getDayOptions = memoize_one_1.default(function (month, year) {
  var maxMonthDay = getMonthMaxDay(month, year);
  var array = [];

  for (var value = 1; value <= maxMonthDay; value++) {
    array.push({
      label: String(value),
      value: String(value),
      clearableValue: false
    });
  }

  return array;
});

exports.yearOptions = function () {
  var yearOptions = [];
  var currentFullYear = new Date().getFullYear();

  for (var value = currentFullYear; value >= 1901; value--) {
    yearOptions.push({
      label: String(value),
      value: String(value),
      clearableValue: false
    });
  }

  return yearOptions;
}();

exports.monthOptions = function () {
  var monthOptions = [];

  for (var value = 1; value <= 12; value++) {
    var monthDate = new Date(2000, value - 1, 1);
    var label = upperCaseFirst_1.default(i18n_1.intlConfig.formatDate(monthDate, {
      month: 'long'
    }));
    monthOptions.push({
      label: label,
      value: String(value),
      clearableValue: false
    });
  }

  return monthOptions;
}();